import _objectSpread2 from '../../../../@babel/runtime/helpers/esm/objectSpread2.js';
import * as React from 'react';
import FlagOutlinedSvg from '../../../icons-svg/es/asn/FlagOutlined.js';
import AntdIcon from '../components/AntdIcon.js';

var FlagOutlined = function FlagOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    icon: FlagOutlinedSvg
  }));
};

FlagOutlined.displayName = 'FlagOutlined';
var FlagOutlined$1 = /*#__PURE__*/React.forwardRef(FlagOutlined);

export { FlagOutlined$1 as default };
